import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const ErrorFallback = ({ error, errorInfo, resetError }) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mx-auto mb-6">
          <ExclamationTriangleIcon className="w-10 h-10 text-red-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
          Something went wrong
        </h1>

        <p className="text-gray-600 text-center mb-6">
          We're sorry, but something unexpected happened. Please try refreshing the page or contact support if the problem persists.
        </p>

        {isDevelopment && error && (
          <div className="mb-6">
            <div className="bg-gray-100 rounded p-4 mb-4">
              <h3 className="text-sm font-semibold text-gray-700 mb-2">Error Details:</h3>
              <p className="text-xs font-mono text-red-600">{error.toString()}</p>
            </div>

            {errorInfo && errorInfo.componentStack && (
              <div className="bg-gray-100 rounded p-4">
                <h3 className="text-sm font-semibold text-gray-700 mb-2">Component Stack:</h3>
                <pre className="text-xs font-mono text-gray-600 overflow-auto max-h-40">
                  {errorInfo.componentStack}
                </pre>
              </div>
            )}
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={() => window.location.reload()}
            className="flex-1 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <ArrowPathIcon className="w-5 h-5 mr-2" />
            Reload Page
          </button>

          {resetError && (
            <button
              onClick={resetError}
              className="flex-1 inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Try Again
            </button>
          )}
        </div>

        <div className="mt-6 text-center">
          <a
            href="/"
            className="text-sm text-blue-600 hover:text-blue-700 hover:underline"
          >
            Return to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
